import React, { useEffect, useState, useRef } from "react";
import { Container, Row, Col } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsTable } from "react-icons/bs";
import html2pdf from "html2pdf.js";
import CardColComponent from "../genericCardComponent/CardColComponent";
import ReportTemplates from "../../components/ReportTemplate/ReportTemplate";
import moment from "moment";
import HBLLogo from "../../assets/image.png";
import { getFundByAmc, getFunds } from "../../stores/services/funds.service";
import Select from "react-select";
import {
  getAllLoanApplications,
  getAllProvidentFunds,
} from "../../stores/services/provident-funds.service";
import { numberWithCommas } from "../../utils/customFunction";
import { useSelector } from "react-redux";
import { getAllCompanies } from "../../stores/services/company.service";

const LoanRecordReport = () => {
  const email = sessionStorage.getItem("email") || "";
  const amc_code = sessionStorage.getItem("amc_code") || "";
  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
  const contentRef = useRef<HTMLDivElement>(null);

  // State
  const [loading, setLoading] = useState(false);
  const [fund, setFund] = useState<string>("");
  const [fundLoading, setFundLoading] = useState<boolean>(false);
  const [allFunds, setAllFunds] = useState<any[]>([]);
  const [folio, setFolio] = useState<string>("");
  const [allFolios, setAllFolios] = useState<any[]>([]);
  const [tableData, setTableData] = useState<any[]>([]);

  // Report config
  const [fontSizeVal, setFontSizeVal] = useState(18);
  const [paperSizeVal, setPaperSizeVal] = useState("A4");
  const [layoutVal, setLayoutVal] = useState("Landscape");
  const [marginPDF, setMarginPDF] = useState("1cm");
  const [scalePDF, setScalePDF] = useState(0.5);
  const [screenSizePerPdf, setScreenSizePerPdf] = useState<any>();
  const [dimensionOfPages, setDimensionOfPages] = useState<any>();
  const pdfExportComponent = useRef(null);

  const [selectedValues, setSelectedValues] = useState({
    heading: "",
    sub_heading: "",
    columns: [],
    balance: [],
  });

  const [loadingCompany, setLoadingCompany] = useState(false);
  const [companyOptions, setCompanyOptions] = useState<any[]>([]);
  const [companyName, setCompanyName] = useState<any>();
  const [companyLogo, setCompanyLogo] = useState<any>();

  // Fetch Companies
  useEffect(() => {
    const fetchAllCompanies = async () => {
      try {
        setLoadingCompany(true);
        const resp = await getAllCompanies({ email, fetch_all: "all" });
        if (resp.data.status === 200) {
          const options = resp.data.data.map((data: any) => ({
            ...data,
            value: data.company_code,
            label: `${data.name_of_company} (${data.company_code})`,
          }));
          setCompanyOptions(options);
        }
      } catch (error) {
        toast.error("Failed to load companies");
      } finally {
        setLoadingCompany(false);
      }
    };
    fetchAllCompanies();
  }, []);

  // Fetch Funds when Company changes
  useEffect(() => {
    const getAllFunds = async () => {
      if (!companyName?.value) return;
      try {
        const res = await getFunds({
          email,
          company_name: companyName.value,
        });
        setAllFunds(res.data.data || []);
      } catch (error) {
        toast.error("Failed to load funds");
      }
    };
    getAllFunds();
  }, [companyName]);

  const getAllEmployees = async (fundIs: string) => {
    try {
      if (!fundIs) {
        setAllFolios([]);
      }
      const response = await getAllProvidentFunds(
        email,
        amc_code,
        fundIs,
        "",
        "",
        "",
        "",
        "",
        "true"
      );
      if (response.data.status === 200) {
        setAllFolios(response.data.data || []);
      }
    } catch (error) {
      toast.error("Failed to load employees.");
    }
  };

  const searchData = async () => {
    if (!fund || !folio) {
      toast.error("Please select both Fund and Employee.");
      return;
    }
    try {
      setLoading(true);
      const response = await getAllLoanApplications(
        email,
        amc_code,
        fund,
        folio,
        "ACCEPTED,PAID"
      );
      if (response.data.status === 200 && response.data.data?.length > 0) {
        const noOfInstallment = response.data.data[0]?.number_of_installment;
        const dataIs = response.data.data[0]?.installments;
        console.log(noOfInstallment, "value", dataIs);
        const result: any[] = [];

        Array.from({ length: noOfInstallment }).forEach((_, index) => {
          // If we have data from API for this index
          if (index < dataIs?.length) {
            console.log("eheee1");
            result.push({
              amount: dataIs[index]?.amount || 0,
              date: dataIs[index]?.date,
              installment_no: index + 1,
              previous_remaining: dataIs[index]?.previous_remaining || 0,
              remaining_after: dataIs[index]?.remaining_after || 0,
            });
          }
          // For indexes beyond API data, create new objects
          else {
            console.log("eheee2");
            const previousItem = result[index - 1]; // Now this works because result is being built
            console.log("eheee3", previousItem);
            result.push({
              amount: 0,
              date: moment(previousItem?.date)
                .add(1, "month")
                .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
              installment_no: index + 1,
              previous_remaining: previousItem?.remaining_after || 0,
              remaining_after: 0,
            });
          }
        });
        console.log("resultsss", result);
        let finalData = response?.data?.data?.map((ele) => {
          return {
            ...ele,
            installments: result || [],
          };
        });
        setTableData(finalData);
      } else {
        setTableData([]);
        toast.error("No loan records found!");
      }
    } catch (error: any) {
      setTableData([]);
      toast.error(error?.response?.data?.message || "Error fetching data.");
    } finally {
      setLoading(false);
    }
  };

  // Dummy export handlers (you can enhance later)
  const handleDownloadExcel = () =>
    toast.info("Export not implemented for nested data.");
  const handleTXT = () => toast.info("Export not implemented for nested data.");

  const handleGeneratePdf = () => {
    const element = contentRef.current;
    if (!element) return;
    const options = {
      filename: "Loan-Report.pdf",
      margin: [10, 3, 20, 3],
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 1 },
      jsPDF: {
        unit: "mm",
        format: paperSizeVal || "A4",
        orientation: layoutVal === "Landscape" ? "landscape" : "portrait",
      },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
    };

    html2pdf()
      .from(element)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          pdf.setFontSize(10);
          pdf.setTextColor(128, 128, 128);
          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          pdf.text(
            "This is a computer-generated report from MACS 360. No signature is required.",
            pageWidth / 2,
            pageHeight - 10,
            { align: "right" }
          );
        }
      })
      .save();
  };

  // Dropdown helpers
  const renderFundsDropdown = () =>
    allFunds.map((item) => ({
      value: item.symbol_code,
      label: `${item.fund_name} (${item.symbol_code})`,
    }));

  const renderAllFoliosDropdown = () => {
    const uniqueFolios = allFolios.filter(
      (item, index, self) =>
        index === self.findIndex((t) => t.folio_no === item.folio_no)
    );
    return uniqueFolios.map((item) => ({
      value: item.folio_no,
      label: `${item.folio_no} - (${item.employee_name})`,
    }));
  };

  const selectedFundName = allFunds.find((f) => f.symbol_code === fund)
    ? {
        value: fund,
        label: `${
          allFunds.find((f) => f.symbol_code === fund)?.fund_name
        } (${fund})`,
      }
    : null;

  const selectedFolioVal = allFolios.find((f) => f.folio_no === folio)
    ? {
        value: folio,
        label: `${folio} - (${
          allFolios.find((f) => f.folio_no === folio)?.employee_name
        })`,
      }
    : null;

  const customStyles = {
    menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
    option: (styles: any, { isFocused, isSelected }: any) => ({
      ...styles,
      background: isFocused
        ? "hsla(291, 64%, 42%, 0.5)"
        : isSelected
        ? "hsla(291, 64%, 42%, 1)"
        : undefined,
      zIndex: 1,
    }),
    menuList: (styles: any) => ({
      ...styles,
      background: theme === "dark" ? "#3b3b3b" : "#ffffff",
      color: theme === "dark" ? "white" : "",
    }),
    menu: (base: any) => ({ ...base, zIndex: 100 }),
    control: (base: any, state: any) => ({
      ...base,
      background: theme === "dark" ? "#25273a" : "#f2f2f2",
      borderRadius: "0.4285rem",
      borderColor: state.isFocused
        ? "#1d8cf8"
        : theme !== "light"
        ? "#2b3553"
        : "",
      boxShadow: state.isFocused ? null : null,
      "&:hover": { borderColor: "#ba54f5" },
    }),
    singleValue: (provided: any) => ({
      ...provided,
      color: theme === "dark" ? "white" : "black",
    }),
    input: (base: any) => ({
      ...base,
      color: theme === "dark" ? "white" : "black",
    }),
  };

  return (
    <div className="content">
      <Row>
        <Col md="12">
          <Container fluid>
            <ToastContainer limit={1} />
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Loan Application Report</h4>
              </div>
              <div className="card-body">
                <Row className="align-items-center">
                  <Col className="form-group col-md-3">
                    <label>
                      Company Name <span className="color-amber">*</span>
                    </label>
                    {console.log("companyName", companyName)}
                    <Select
                      className="react-select info"
                      isLoading={loadingCompany}
                      value={companyName}
                      onChange={setCompanyName}
                      menuPortalTarget={document.body}
                      menuShouldBlockScroll
                      isClearable
                      isSearchable
                      options={companyOptions}
                      styles={customStyles}
                    />
                  </Col>
                  <Col md="3" xs="12" className="mb-3 mb-md-0">
                    <div className="form-group">
                      <label>Fund</label>
                      {fundLoading ? (
                        <div className="form-control w-100">
                          <i className="fa fa-spinner fa-spin fa-1x"></i>
                        </div>
                      ) : (
                        <Select
                          value={selectedFundName}
                          onChange={(e) => {
                            setFund(e?.value || "");
                            getAllEmployees(e?.value || "");
                          }}
                          isDisabled={!companyName?.value}
                          isClearable
                          isSearchable
                          options={renderFundsDropdown()}
                          styles={customStyles}
                          menuPortalTarget={document.body}
                          menuShouldBlockScroll
                        />
                      )}
                    </div>
                  </Col>
                  <Col md="3" xs="12" className="mb-3 mb-md-0">
                    <div className="form-group">
                      <label>Select Employee</label>
                      <Select
                        value={selectedFolioVal}
                        onChange={(e) => setFolio(e?.value || "")}
                        isClearable
                        isSearchable
                        options={renderAllFoliosDropdown()}
                        styles={customStyles}
                        menuPortalTarget={document.body}
                        menuShouldBlockScroll
                      />
                    </div>
                  </Col>
                  <Col
                    md="auto"
                    xs="6"
                    className="d-flex align-items-end mt-3 mb-md-0"
                  >
                    <button
                      className="btn btn-primary"
                      onClick={searchData}
                      disabled={loading || !fund || !folio}
                    >
                      {loading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                          />
                          <span className="ms-1">Loading...</span>
                        </>
                      ) : (
                        "Search"
                      )}
                    </button>
                  </Col>
                </Row>
              </div>
            </div>

            {/* Report Output */}
            <div className="card mt-3">
              <div className="card-body">
                {tableData.length > 0 && (
                  <Row>
                    <ReportTemplates
                      ColumnArr={[]}
                      selectedValues={selectedValues}
                      setSelectedValues={setSelectedValues}
                      pdfExportComponent={pdfExportComponent}
                      setFontSizeVal={setFontSizeVal}
                      fontSizeVal={fontSizeVal}
                      setPaperSizeVal={setPaperSizeVal}
                      paperSizeVal={paperSizeVal}
                      setLayoutVal={setLayoutVal}
                      layoutVal={layoutVal}
                      setScalePDF={setScalePDF}
                      scalePDF={scalePDF}
                      setMarginPDF={setMarginPDF}
                      marginPDF={marginPDF}
                      setScreenSizePerPdf={setScreenSizePerPdf}
                      screenSizePerPdf={screenSizePerPdf}
                      setDimensionOfPages={setDimensionOfPages}
                      contentRef={contentRef}
                      fileName="Loan-Report.pdf"
                      printExcel={handleDownloadExcel}
                      printTXT={handleTXT}
                      printpdf={handleGeneratePdf}
                    />
                  </Row>
                )}

                <div
                  id="printDiv"
                  className="p-4"
                  style={{
                    color: "black",
                    minWidth: "200px",
                    overflowX: "auto",
                    width: "auto",
                  }}
                >
                  <div
                    style={{
                      width: `${
                        dimensionOfPages?.find(
                          (item) => item.key === paperSizeVal
                        )?.dimensions[layoutVal === "Portrait" ? 0 : 1]
                      }`,
                      margin: "0 auto",
                      backgroundColor: "white",
                    }}
                    className="border"
                  >
                    <div style={{ margin: "0.25in" }} ref={contentRef}>
                      {tableData.length === 0 ? (
                        <div className="table-empty text-center">
                          <BsTable className="icon" />
                          <p className="text-primary">
                            No Loan Report data found.
                          </p>
                        </div>
                      ) : (
                        tableData.map((loan, idx) => {
                          // Prepare summary data for CardColComponent
                          const amount_per_inst =
                            (+loan?.loan_amount || 0) /
                            (+loan.number_of_installment || 0);
                          const loanSummary = [
                            {
                              title: "Fund Code",
                              value: loan.symbol_code,
                              isAmount: false,
                            },
                            {
                              title: "Fund Name",
                              value: loan.fund_name,
                              isAmount: false,
                            },
                            {
                              title: "Employee Code",
                              value: loan.folio_no,
                              isAmount: false,
                            },
                            {
                              title: "Employee Name",
                              value: loan.employee_name,
                              isAmount: false,
                            },
                            {
                              title: "Loan Amount",
                              value: loan.loan_amount,
                              isAmount: true,
                              fixed: 2,
                            },
                            {
                              title: "Total Loan Applicable",
                              value: loan.total_loan_applicable,
                              isAmount: true,
                              fixed: 2,
                            },
                            // {
                            //   title: "Remaining Loan",
                            //   value: loan?.loan_refundable ? loan.remaining_loan : 0,
                            //   isAmount: true,
                            //   fixed: 2,
                            // },
                            // {
                            //   title: "Installments",
                            //   value: loan.number_of_installment,
                            //   isAmount: false,
                            // },
                            // {
                            //   title: "Amount Per installment",
                            //   value: loan?.loan_refundable ? numberWithCommas(amount_per_inst) : 0,
                            //   isAmount: false,
                            // },
                          ];
                          if (loan?.loan_refundable) {
                            loanSummary.push(
                              {
                                title: "Remaining Loan",
                                value: loan?.loan_refundable
                                  ? loan.remaining_loan
                                  : 0,
                                isAmount: true,
                                fixed: 2,
                              },
                              {
                                title: "Installments",
                                value: loan.number_of_installment,
                                isAmount: false,
                              },
                              {
                                title: "Amount Per installment",
                                value: loan?.loan_refundable
                                  ? numberWithCommas(amount_per_inst)
                                  : 0,
                                isAmount: false,
                              }
                            );
                          }

                          return (
                            <div key={idx} className="mb-4">
                              <div className="row align-items-center">
                                <div className="col-4 d-flex justify-content-start">
                                  <img
                                    // src={companyName?.company_logo ? companyName?.company_logo : HBLLogo}
                                    src={
                                      companyName?.company_logo
                                        ? companyName?.company_logo
                                        : ""
                                    }
                                    alt="Vertices-Logo"
                                    style={{
                                      width: "auto",
                                      height: "33px",
                                    }}
                                  />
                                </div>
                                <div className="col-4 d-flex flex-column align-items-center justify-content-center">
                                  <h6 className="text-black mt-2 mb-0">
                                    Employee Loan Report
                                  </h6>
                                </div>
                              </div>
                              {/* Summary Card in requested UI style */}
                              <Col className="px-0" xs={12}>
                                <div className={`m-1 p-2 small`}>
                                  <div
                                    className={`card-header py-2 px-3 border-bottom`}
                                  >
                                    <div
                                      className={`text-black d-flex align-items-center`}
                                    >
                                      <span>Loan Summary</span>
                                    </div>
                                  </div>
                                  <div className={`text-black card-body p-2`}>
                                    <div className="d-flex flex-wrap">
                                      {loanSummary.map((item, i) => (
                                        <div
                                          className="flex-item pr-5 pb-3"
                                          key={i}
                                        >
                                          <CardColComponent
                                            title={item.title}
                                            subTitle={
                                              item.isAmount
                                                ? numberWithCommas(
                                                    parseFloat(
                                                      item.value ?? 0
                                                    ).toFixed(item.fixed ?? 2)
                                                  )
                                                : item.value
                                            }
                                            amount={item.isAmount}
                                            report={true}
                                          />
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              </Col>

                              {/* Installments Table */}
                              {loan.installments &&
                              loan.installments.length > 0 ? (
                                <div className="mt-3">
                                  <h6 className="mb-2">Installments</h6>
                                  <table
                                    className="w-100"
                                    style={{ borderCollapse: "collapse" }}
                                  >
                                    <thead>
                                      <tr
                                        style={{
                                          borderTop: "2px solid black",
                                          borderBottom: "2px solid black",
                                        }}
                                      >
                                        <th
                                          style={{
                                            padding: "8px 4px",
                                            textAlign: "left",
                                          }}
                                        >
                                          #
                                        </th>
                                        <th
                                          style={{
                                            padding: "8px 4px",
                                            textAlign: "left",
                                          }}
                                        >
                                          Date
                                        </th>
                                        <th
                                          style={{
                                            padding: "8px 4px",
                                            textAlign: "right",
                                          }}
                                        >
                                          Amount
                                        </th>
                                        <th
                                          style={{
                                            padding: "8px 4px",
                                            textAlign: "right",
                                          }}
                                        >
                                          Prev. Remaining
                                        </th>
                                        <th
                                          style={{
                                            padding: "8px 4px",
                                            textAlign: "right",
                                          }}
                                        >
                                          Remaining After
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {loan.installments.map((inst, i) => (
                                        <tr className="border-bottom" key={i}>
                                          <td style={{ padding: "6px 4px" }}>
                                            {inst.installment_no}
                                          </td>
                                          <td style={{ padding: "6px 4px" }}>
                                            {moment(inst.date).format(
                                              "MMM, YYYY"
                                            )}
                                          </td>
                                          <td
                                            style={{
                                              padding: "6px 4px",
                                              textAlign: "right",
                                            }}
                                          >
                                            {numberWithCommas(inst.amount)}
                                          </td>
                                          <td
                                            style={{
                                              padding: "6px 4px",
                                              textAlign: "right",
                                            }}
                                          >
                                            {numberWithCommas(
                                              inst.previous_remaining
                                            )}
                                          </td>
                                          <td
                                            style={{
                                              padding: "6px 4px",
                                              textAlign: "right",
                                            }}
                                          >
                                            {numberWithCommas(
                                              inst.remaining_after
                                            )}
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              ) : (
                                <p className="text-muted mt-2">
                                  No installments recorded.
                                </p>
                              )}
                            </div>
                          );
                        })
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </Col>
      </Row>
    </div>
  );
};

export default LoanRecordReport;
